export default {
  data() {
    return {
      navList: []
    };
  },
  created() {
    const navList = this.$store.state.app.navList;
    const rule1 = ['news', 'trading-rules'].includes(this.$route.path.split('/')[1]);
    const rule2 = ['contracting-pay-list'].includes(this.$route.path.split('/')[4]);
    if (rule1 || rule2) {
      this.navList = navList || [];
    } else {
      this.getShowNavList();
    }
    // this.replaceBreadSymbol();
  },
  watch: {
    $route: function() {
      const navList = this.$store.state.app.navList;
      const rule1 = ['news', 'trading-rules'].includes(this.$route.path.split('/')[1]);
      const rule2 = ['contracting-pay-list'].includes(this.$route.path.split('/')[4]);
      if (rule1 || rule2) {
        this.navList = navList || [];
      } else {
        this.getShowNavList();
      }
      // this.replaceBreadSymbol();
    }
  },
  computed: {
    isShowBread() {
      if (this.$route.meta && this.$route.meta.breadCrumbShowIndexArr && this.$route.meta.breadCrumbShowIndexArr.length) {
        return true;
      }
      return false;
    }
  },
  methods: {
    // 替换面包屑连接符
    // replaceBreadSymbol () {
    //   this.$nextTick(() => {
    //     const separatorList = document.querySelectorAll('.el-breadcrumb__separator');
    //     separatorList.forEach(item => {
    //       item.innerHTML = '>';
    //     });
    //   });
    // },
    getShowNavList() {
      this.navList = [];
      const list = this.$route.matched.filter((item, index) => {
        if (!(this.$route.meta && this.$route.meta.breadCrumbShowIndexArr && this.$route.meta.breadCrumbShowIndexArr.includes(index))) {
          return false;
        }
        return true;
      });
      const navList = list.map(v => {
        return {path: v.redirect || v.path, title: v.meta.title};
      });
      this.navList = [{path: '/index', title: '首页'}, ...navList];
    },
    breadcrumbItemToPath (index) {
      console.log(1111, index);
      if ((this.navList.length === 1) || (index === this.navList.length - 1)) {
        return '';
      }
      if (this.$route.query && this.$route.query.id) {
        return this.navList[index].path + '?id=' + this.$route.query.id;
      } else {
        return this.navList[index].path;
      }
    }
  }
};
